module.exports = __webpack_public_path__ + "media/images/design/common/images/menu05-4e063792e5737235ffc9c41929dd5a08.jpg";